import {MMKV} from '@bsky.app/react-native-mmkv'
import {setPolyfills} from '@growthbook/growthbook'
import {GrowthBook} from '@growthbook/growthbook-react'

import {type Metadata} from '#/analytics/metadata'
import * as env from '#/env'

export {Features} from '#/analytics/features/types'

const CACHE = new MMKV({id: 'bsky_features_cache'})

setPolyfills({
  localStorage: {
    getItem: key => {
      return CACHE.getString(key) ?? null
    },
    setItem: async (key, value) => {
      CACHE.set(key, value)
    },
  },
})

/**
 * We vary the amount of time we wait for GrowthBook to fetch feature
 * gates based on the strategy specified.
 */
export type FeatureFetchStrategy = 'prefer-low-latency' | 'prefer-fresh-gates'

export const features = new GrowthBook({
  apiHost: env.GROWTHBOOK_API_HOST,
  clientKey: env.GROWTHBOOK_CLIENT_KEY,
})

/**
 * Initializer promise that must be awaited before using the GrowthBook
 * instance or rendering the `AnalyticsFeaturesContext`. Note: this may not be
 * fully initialized if it takes longer than `TIMEOUT_INIT` to initialize. In
 * that case, we may see a flash of uncustomized content until the
 * initialization completes.
 */
/*
 * Batesky: GrowthBook remote fetching is disabled so the app does not phone
 * home to `events.bsky.app/gb`. We intentionally DO NOT call `features.init()`
 * (which fetches remote gates) or upload any attributes. Feature flags fall
 * back to their in-code defaults. To re-enable, restore the `features.init` /
 * `refreshFeatures` / `setAttributes` calls from upstream social-app.
 */
export const init = Promise.resolve()

/**
 * Refresh feature gates from GrowthBook. Disabled in Batesky (no-op) to avoid
 * network calls to `events.bsky.app/gb`.
 */
export async function refresh(_args: {strategy: FeatureFetchStrategy}) {
  // no-op: telemetry/remote-config disabled
}

/**
 * Set GrowthBook attributes. Disabled in Batesky (no-op) so device/session/user
 * attributes are never uploaded for experiment bucketing.
 */
export function setAttributes(_metadata: Metadata) {
  // no-op: telemetry/remote-config disabled
}
